import React from "react";
// import { Link } from "react-router-dom";
// import OurTeam from "../pages/OurTeam";
import "./styles/footer.css";

const FooterCom = () => {
  return (
    <div className="footer">
      <p>@ Cultivo All Rights Reseverd</p>
    </div>
  );
};

export default FooterCom;
